<template>
  <van-tabs v-model="active" animated swipeable @change="onTabClick">
    <van-tab title="代账服务">
      <div v-if="ashowNoData && accountData.length == 0" class="empty">
        <img src="../../assets/images/bnodata.png" alt="">
        <div class="desc">暂无服务动态</div>
      </div>
      <div v-else class="content">
        <div class="blockTd" v-for="item in accountData" :key="item.id">
          <div class="taxTd">
            <van-row class="topRow">
              <van-col span="24">{{item.createDate}}</van-col>
            </van-row>
            <van-row  class="confirmedRow lh37" @click.native="linkSkip('accountServices',{accountInfo:item,scoreId:item.scoreId,customerId:item.customerId},'50010053')">
              <van-col span="3" class="confirmedRowCol lh37">
                <i class="iconfont icon-account_service fs24"></i>
              </van-col>
              <van-col span="13" class="confirmedRowCol lh37">
                <div class="stitle">代账服务</div>
              </van-col>
              <van-col span="8" class="confirmedRowCol">
                <div class="rightText">
                  {{item.accountDate ? (item.accountDate.slice(0, 4) +"年" +  (item.accountDate.slice(5) >= 10 ? item.accountDate.slice(5) : item.accountDate.slice(6)) +"月") : ''}}
                  <van-icon name="arrow"/>
                  <!-- <span v-show="item.dealStatus == 0" class="bandge"></span> -->
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </van-tab>
    <van-tab title="工商服务">
      <div v-if="bshowNoData && businessData.length == 0" class="empty">
        <img src="../../assets/images/bnodata.png" alt="">
        <div class="desc">暂无服务动态</div>
      </div>
      <div v-else class="content">
        <div class="blockTd" v-for="item in businessData" :key="item.id">
          <div class="orderTd">
            <van-row 
              class="topRow"
            >
              <van-col span="24">{{item.createDate}}</van-col>
            </van-row>
            <van-row
              class="confirmedRow confirmedInvest lh37"
              @click.native="linkSkip('businessServices',{serviceId:item.acctOrderServiceId,scoreId:item.scoreId,customerId:item.customerId,status:item.status},'50010054')"
            >
              <van-col span="3" class="confirmedRowCol">
                <i class="iconfont icon-business_service fs24 primary"></i>
              </van-col>
              <van-col span="13" class="confirmedRowCol">
                <div class="stitle">{{item.serviceName}}</div>
              </van-col>
              <van-col span="8" class="confirmedRowCol">
                <div class="rightText">
                  {{item.currentNodeName}}
                  <van-icon name="arrow"/>
                  <!-- <span v-show="item.dealStatus == 0" class="bandge"></span> -->
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
import Vue from "vue";
import { Tab, Tabs, Row, Col, Toast } from "vant";

Vue.use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col);
export default {
  name: "serviceIndex",
  data() {
    return {
      active: 0,
      companyId: this.$store.state.companyInfo,
      data: [],
      accountData: [],
      businessData: [],
      ashowNoData: false,
      bshowNoData: false,
      fromAcctCustomerInfo:this.$store.state.fromAcctCustomerInfo,
    };
  },
  beforeRouteEnter (to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    console.log('进来了:' + from.path)
    next(vm => {
      if (from.path.indexOf('/companyHome') < 0) {
        vm.active = parseInt(window.sessionStorage.getItem('s_active'))
        console.log(vm.active,"vm.active");
        window.sessionStorage.removeItem('s_active')
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    window.sessionStorage.setItem('s_active', this.active)
    if (to.path.indexOf('/companyHome') > -1) {
      window.sessionStorage.removeItem('s_active')
    }
    if (to.path.indexOf('/businessServices') > -1 || to.path.indexOf('/accountServices') > -1) {
      window.sessionStorage.setItem('s_active', this.active)
    }
    console.log('离开了:' + to.path)
    next()
  },
  beforeMount() {
    this.active = parseInt(window.sessionStorage.getItem('s_active')) || 0
  },
  mounted() {
    console.log(this.active,"this.active");
    this.$root.$emit('log-record',"50010049");
    if(this.active == 0){
      this.getAccountService()
    }else if(this.active == 1){
      this.getBusinessService()
    }  
  },
  methods : {
    linkSkip(name, params, rid) {
      if(rid){
        this.$root.$emit('log-record',rid);
      }
      // params.serviceList = this.businessData
      this.$router.push({
        name: name,
        query: params
      });
    },
    onTabClick(index){
      // this.$router.push({query: {active: index}});
      if(index == 0){
        if(!this.ashowNoData){
          this.getAccountService()
        }
        this.$root.$emit('log-record',"50010050");
      }else if(index == 1){
        if(!this.bshowNoData){
          this.getBusinessService()
        }
        this.$root.$emit('log-record',"50010051");
      }
      this.active = index
    },
    getAccountService () {
      Toast.loading({mask: true,message: '加载中...'});
      let url = Object.keys(this.fromAcctCustomerInfo).length > 0 ? ("/fc/small/program/dzfwlist?dbId=" + this.fromAcctCustomerInfo.databaseId + '&companyId=' + this.fromAcctCustomerInfo.companyId) : ("/fc/small/program/dzfwlist")
      this.$http.get(url).then((res) => {
        console.log(JSON.stringify(res));
        this.ashowNoData = true
        if (res.data.code == 200) {
          Toast.clear()
          let result = res.data.data
          if (result.businessList.length > 0) {
            this.accountData = result.businessList
            
          }
        }
      }).catch(error => {
        Toast.clear()
        console.log(error, "error");
      });
    },
    getBusinessService () {
      Toast.loading({mask: true,message: '加载中...'});
       let url = Object.keys(this.fromAcctCustomerInfo).length > 0 ? ("/fc/small/program/list/business?dbId=" + this.fromAcctCustomerInfo.databaseId + '&companyId=' + this.fromAcctCustomerInfo.companyId) : ("/fc/small/program/list/business")
      this.$http.get(url).then((res) => {
        // console.log(JSON.stringify(res));
        this.bshowNoData = true
        Toast.clear()
        if (res.data.code == 200) {
          let result = res.data.data
          if (result.businessList.length > 0) {
            this.businessData = result.businessList
          }
        }
      })
      .catch(error => {
        Toast.clear();
        console.log(error, "error");
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.van-tabs{
  .van-tabs__content.van-tabs__content--animated{
    margin: 0 0.12rem;
  }
  .van-tab__pane{
    .content{
      padding: 0 0.12rem;
      margin-top: 0.1rem;
      background: #f0f2f2;
    }
  }
}

.empty {
  text-align: center;
  margin-top: 1.4rem;
  img{
      width:0.8rem;
  }
  .desc {
    margin-top: 0.08rem;
    color: #B4BEC7;
    font-size:0.12rem;
  }
}
.blockTd{
  margin-bottom: 0.1rem;
  padding: 0.12rem;
  background: #ffffff;
  border-radius:6px;
}

.topRow{
  color: #8896a4;
  font-size: 0.12rem;
  border-bottom:1px solid #e6ebf0;
  padding-bottom: 0.08rem;
  .rightText{
    text-align:right;
  }
}
.confirmedRow {
  margin-top:0.08rem;
  img {
    height: 0.22rem;
    width: 0.22rem;
    margin-top: 0.075rem;
  }

  .stitle {
    font-size: 0.16rem;
    color: #2C3E50;
  }

  .stitleDesc {
    color: #8896A4;
    font-size: 0.12rem;
  }

  .rightText {
    text-align: right;
    line-height: 0.37rem;
    color: #8896A4;
    font-size: 0.12rem;
    position: relative;

    .bandge {
      display: inline-block;
      width: 4px;
      height: 4px;
      background-color: #FE4E21;
      border-radius: 100%;
      position: absolute;
      right: 0.16rem;
      top: 0.02rem;
    }

    .van-icon-arrow:before {
      position: relative;
      top: 0.02rem;
    }
  }
}
</style>

